
import { ClientNewsAlert } from "../../types";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { formatDistanceToNow } from "date-fns";
import { ExternalLink, CheckCircle2, Circle } from "lucide-react";

interface NewsAlertItemProps {
  alert: ClientNewsAlert;
  onMarkAsRead: (alertId: string) => void;
  onMarkAsUnread: (alertId: string) => void;
}

export const NewsAlertItem: React.FC<NewsAlertItemProps> = ({ alert, onMarkAsRead, onMarkAsUnread }) => {
  return (
    <div className="border rounded-lg p-4 space-y-3">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="font-medium line-clamp-2">{alert.title}</h3>
            {!alert.is_read && (
              <Badge variant="secondary" className="text-xs">New</Badge>
            )}
          </div>
          
          {alert.content && (
            <p className="text-sm text-muted-foreground line-clamp-3 mb-2">
              {alert.content}
            </p>
          )}
          
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span>{alert.source}</span>
            <span>
              {alert.published_at 
                ? formatDistanceToNow(new Date(alert.published_at), { addSuffix: true })
                : formatDistanceToNow(new Date(alert.created_at), { addSuffix: true })
              }
            </span>
          </div>
        </div>
        
        <div className="flex items-center gap-2 ml-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => alert.is_read ? onMarkAsUnread(alert.id) : onMarkAsRead(alert.id)}
            aria-label={alert.is_read ? "Mark as unread" : "Mark as read"}
          >
            {alert.is_read ? (
              <Circle className="h-4 w-4" />
            ) : (
              <CheckCircle2 className="h-4 w-4" />
            )}
          </Button>
          
          {alert.url && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => window.open(alert.url, '_blank')}
            >
              <ExternalLink className="h-4 w-4 mr-2" />
              Read Article
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
